<template>
    <div ref="diagram" :class="!isFull ? 'diagram' : 'full'" :style="kuan ? kuanStyle : ''">
        <div class="move-box">
            <!-- //遮罩层 -->
            <div class="upmask"></div>
            <!-- <iframe v-if="$store.state.homeitem.apk=='CH0001'"  src="http://ch.vedio.vrmaker.vip:7001/maker/test.html?id=1" frameborder="0" class="small" width="100%" height="100%" ></iframe> -->
            <iframe frameborder="0" class="small" :class="isFull?'isFull':''" :src="
          'https://local.vrmaker.vip:1443/webrtc/index.html?' +($store.state.homeitem.apk?
          $store.state.homeitem.apk:$store.state.homeitem.monitoring.videoCode)
        ">
            </iframe>
            
            <!-- //遮罩层 -->
            <!-- <div class="Downmask"></div> -->
            <div class="Photovoltaic" v-show="PhotovoltaicShow">
                <div class="button" @click="checkLight"><img src="../../../assets/img/gf.png" alt=""></div>
                <canvas id="canvas" style="width: 1920px; height: 937px" ></canvas>
                <div class="Inverter" v-show="PhotovoltaicShow2">
                    <!-- <img src="../../../assets/img/nbq.png" alt="" class="nbq">
                    <img src="../../../assets/img/line.png" alt="" class="line">
                    <img src="../../../assets/img/line1.png" alt="" class="line1"> -->
                    <div class="bom" >
                        <div class="text row-center">
                            <div class="item">
                                <span>{{Number(Number(mqttval(InverterList[0].subLoopUrl+'/Daily_Power_Generation'))+Number(mqttval(InverterList[1].subLoopUrl+'/Daily_Power_Generation'))).toFixed(2)}}</span>
                                <p>日总发电量(kWh)</p>
                            </div>
                            <div class="item">
                                <span>{{Number(Number(mqttval(InverterList[0].subLoopUrl+'/Total_Power_Generation'))+Number(mqttval(InverterList[1].subLoopUrl+'/Total_Power_Generation'))).toFixed(2)}}</span>
                                <p>累计发电量(kWh)</p>
                            </div>
                        </div>
                        <div class="info" v-for="item in InverterList">
                            <div class="tt">{{item.loopName}}</div>
                            <div class="cont row-center">
                                <div class="item">
                                    <span>{{mqttval(item.subLoopUrl+'/Daily_Power_Generation')}}</span>
                                    <p>今日发电量(kWh)</p>
                                </div>
                                <div class="item">
                                    <span>{{mqttval(item.subLoopUrl+'/Total_Power_Generation')}}</span>
                                    <p>累计发电量(kWh)</p>
                                </div>
                                <div class="item">
                                    <span>{{mqttval(item.subLoopUrl+'/Temperature')}}</span>
                                    <p>机内空气温度(℃)</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="box" id="box"  style="position:absolute;display: none;">
                    <div class="tt" >组串{{index}}</div>
                    <div class="cont">
                        <span>{{mqttval1("I_Series"+(index))}}</span>
                        <p>直流电流(A)</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="btn row-center" v-show="!kuan" v-if="!isFull" @click="full">
            <!-- <img src="@/assets/img/fullScreen.png" alt="全屏"> -->
            <span><img src="@/assets/img/full.png" title="全屏"></span>
        </div>
        <div class="btn row-center" v-else @click="cancelFull">
            <!-- <img src="@/assets/img/full_cancel.png" alt="取消全屏"> -->
            <span><img src="@/assets/img/qwhite.png" title="取消全屏"></span>
        </div>

        <div class="btn row-center" v-if="!isFull && !kuan" @click="onkuan" style="right: 66rem">
            <!-- <img src="@/assets/img/fullScreen.png" alt="全屏"> -->
            <span style="margin-right: 18px"><img src="@/assets/img/widescreen.png" title="宽屏"></span>
        </div>

        <div v-show="!isFull" class="btn row-center" v-else @click="kuan = false" style="right: 20rem">
            <!-- <img src="@/assets/img/fullScreen.png" alt="全屏"> -->
            <span style=""><img src="@/assets/img/kwhite.png" title="取消宽屏"></span>
        </div>
    </div>
</template>

<script>
	import { floatFormat } from "../../../util/MathUtil";
    import {
        InverterArea
    } from "../../../api/power";
    
    import {
        subscribe,
        unsubscribe,
        subscribeByNodes
    } from "../../../mqtt/index";
    import {
        subscribe as alarmSubscribe,
        unsubscribe as alarmUnsubscribe,
    } from "../../../mqtt/alarm";
    export default {
        name: "VideoHome",
        props: ["videoList"],
        data() {
            return {
                kuan: false,
                // 全屏
                isFull: false,
                PhotovoltaicShow:false,
                PhotovoltaicShow2:false,
                index:0,
                list1:[
                    [[1503,1078],
                    [1457,410],
                    [1360,389],
                    [685,1079]],

                    [[685,1079],
                    [1360,389],
                    [1269,378],
                    [189,851]],

                    
                    [[189,851],
                    [1269,378],
                    [1181,365],
                    [190,640],],
                    
                    [[190,640],
                    [1181,365],
                    [1080,346],
                    [189,539],],

                    [[190,539],
                    [1080,346],
                    [970,325],
                    [194,466],],

                    [[194,466],
                    [970,325],
                    [874,314],
                    [189,409],],

                    
                    [[1452,409],
                    [1448,346],
                    [1408,338],
                    [1358,389],],
                    
                    [[1358,389],
                    [1408,338],
                    [1359,331],
                    [1269,377],],
                    
                    [[1269,377],
                    [1359,331],
                    [1277,319],
                    [1174,364],],
                    
                    [[1174,364],
                    [1277,319],
                    [1203,309],
                    [1069,346],],
                ],
                list:[
                    // [[493,386],
                    // [587,379],
                    // [1262,930],
                    // [490,927]],

                    // [[587,379],
                    // [688,369],
                    // [1724,754],
                    // [1724,934],
                    // [1261,929]],
                    
                    // [[688,369],
                    // [785,357],
                    // [1725,586],
                    // [1725,754]],

                    // [[785,357],
                    // [887,353],
                    // [1725,499],
                    // [1725,585]],

                    // [[887,353],
                    // [987,344],
                    // [1725,449],
                    // [1725,497]],

                    // [[987,344],
                    // [1067,337],
                    // [1725,416],
                    // [1725,448]],

                    // [[1067,337],
                    // [1180,326],
                    // [1725,389],
                    // [1725,416]],

                    // [[492,332],
                    // [533,328],
                    // [588,379],
                    // [493,386]],

                    // [[533,328],
                    // [574 ,323],
                    // [688,369],
                    // [587,379]],

                    // [[574,323],
                    // [623, 318],
                    // [781, 357],
                    // [686, 368]],

                    // [[623, 318],
                    // [684, 312],
                    // [887,353],
                    // [785,357]],
                    
                    // [[684 ,312],
                    // [728, 308],
                    // [985 ,345],
                    // [899, 354]],
                    [[1500,933],
                    [1452,339],
                    [1371,332],
                    [698,925]],

                    [[698,925],
                    [1371,332],
                    [1271,325],
                    [189,737]],

                    [[189,737],
                    [1271,325],
                    [1185,314],
                    [191,558]],

                    [[191,558],
                    [1185,314],
                    [1081,298],
                    [191,466]],

                    [[191,466],
                    [1081,298],
                    [981,285],
                    [191,412]],

                    [[191,412],
                    [981,285],
                    [877,275],
                    [191,368]],

                    [[1452,339],
                    [1448,300],
                    [1410,295],
                    [1370,332]],

                    [[1370,332],
                    [1410,295],
                    [1368,289],
                    [1268,325]],

                    [[1268,325],
                    [1368,289],
                    [1292,279],
                    [1183,313]],

                    [[1183,313],
                    [1292,279],
                    [1212,271],
                    [1082,299]],
                    // [[688,369],
                    // [785,357],
                    // [1725,586],
                    // [1725,754]],

                    // [[785,357],
                    // [887,353],
                    // [1725,499],
                    // [1725,585]],

                    // [[887,353],
                    // [987,344],
                    // [1725,449],
                    // [1725,497]],

                    // [[987,344],
                    // [1067,337],
                    // [1725,416],
                    // [1725,448]],

                    // [[1067,337],
                    // [1180,326],
                    // [1725,389],
                    // [1725,416]],

                    // [[492,332],
                    // [533,328],
                    // [588,379],
                    // [493,386]],

                    // [[533,328],
                    // [574 ,323],
                    // [688,369],
                    // [587,379]],

                    // [[574,323],
                    // [623, 318],
                    // [781, 357],
                    // [686, 368]],

                    // [[623, 318],
                    // [684, 312],
                    // [887,353],
                    // [785,357]],
                    
                    // [[684 ,312],
                    // [728, 308],
                    // [985 ,345],
                    // [899, 354]],

                ],
                boxList1:[
                    // [492,332],
                    // [785,300],
                    // [890,303],
                    // [892,320],
                    // [980,327],
                    // [1095,335],
                    // [1236,319],
                    // [1724,375],
                    // [1726,935],
                    // [490,930],
                    // [492,332],
                    [1503,1078],
                    // [1449,336],
                    [1448,346],
                    [1156,301],
                    [973,324],
                    [831,308],
                    [190,378],
                    [192,1079],
                    [1503,1078],
                ],
                boxList:[
                    // [492,332],
                    // [785,300],
                    // [890,303],
                    // [892,320],
                    // [980,327],
                    // [1095,335],
                    // [1236,319],
                    // [1724,375],
                    // [1726,935],
                    // [490,930],
                    // [492,332],
                    [1499,933],
                    [1449,301],
                    [1157,260],
                    [1066,275],
                    [978,284],
                    [816,269],
                    [190,332],
                    [189,934],
                    [1499,933],
                ],
                canvasShow:true,
                InverterList:[],
                box:null,
                context:null,
                canvas:null,
                checklist:[],
                H:1,
                W:220
            };
        },

        computed: {
            kuanStyle() {
                if (this.kuan) {
                    return `
                    width: 84%;
                    height:90%;
                    position: fixed;
                    top: 6%;
                    left: 14%;
                    bottom: 0;
                    right: 0;
                    margin: auto;
                    z-index: 9999;
                `;
                }
                return;
            },
            StringData(){
                let obj = []
                for (let index = 1; index <= 18; index++) {
                    obj.push({
                        name:"组串"+index,
                        I:"I_Series"+index
                    })
                }
                return obj
			},
			mqttval() {
				return this.getMqttVal(this.$store.getters.mqttVal);
			},
			mqttval1() {
				return this.getMqttVal1(this.$store.getters.mqttVal);
			},
        },
        watch:{
            // "$store.state.homeitem.apk"(n,o){
            //     if(n=='CH0001'&&this.isFull){
            //         this.PhotovoltaicShow = true
            //     }else{
            //         this.PhotovoltaicShow = false
            //     }
            // }
        },
        mounted(){
            let self = this
            // self.H = parseInt(1920/document.documentElement.clientWidth)
            self.W = 230
            console.log(document.documentElement.clientWidth,document.documentElement.clientHeight)
            if(document.documentElement.clientHeight>937){
                // self.list = self.list1
                // self.boxList = self.boxList1
            }
            this.getInverterArea()
        },
        methods: {
            async getInverterArea(){
                let areaId = 25
                let response = await InverterArea(areaId);
                this.InverterList = response.data.data.loops || [];
                this.InverterList.forEach(item=>{
                    subscribe([item.subLoopUrl]);
                    alarmSubscribe([item]);
                })
            },
			getMqttVal(f) {
				// let currentLoop = "T1/1AA2/SG"
				return (k, m) => {
					if (k) {
						// k = currentLoop + "/" + k;
						let mqttVal = f(k);
						if (m) {
							mqttVal *= m;
						}
						mqttVal = floatFormat(mqttVal, 2);
						if (typeof mqttVal === "object") {
							return mqttVal;
						}
						return mqttVal !== undefined && !isNaN(mqttVal) ? mqttVal : "--";
					} else {
						return "--";
					}
				};
			},
			getMqttVal1(f) {
				let currentLoop = "T1/1AA2/SG"
				return (k, m) => {
					if (k) {
						k = currentLoop + "/" + k;
						let mqttVal = f(k);
						if (m) {
							mqttVal *= m;
						}
						mqttVal = floatFormat(mqttVal, 2);
						if (typeof mqttVal === "object") {
							return mqttVal;
						}
						return mqttVal !== undefined && !isNaN(mqttVal) ? mqttVal : "--";
					} else {
						return "--";
					}
				};
			},
            checkLight(){
                let self = this;
                self.PhotovoltaicShow2 = true
                 let canvas=document.getElementById("canvas");
                let element=document.getElementById("box");
                // canvas.width=canvas.clientWidth*window.devicePixelRatio;
                // canvas.height=canvas.clientHeight*window.devicePixelRatio;
                canvas.width = 1920
                canvas.height=937;
                this.canvas = canvas
                this.canvas.width = canvas.width
                this.canvas.height = canvas.height
                let box=canvas.getContext("2d")
                let context=canvas.getContext("2d")
                this.box = box
                this.context = context
                self.canvasShow = !self.canvasShow
                if(self.canvasShow){
                    var w = canvas.width;
                    var h = canvas.height;
                    box.clearRect(0, 0, w, h);
                    context.clearRect(0, 0, w, h);
                    element.style.display = "none"
                    self.PhotovoltaicShow2 = false
                }else{
                    box.beginPath();
                    // box.moveTo(492,332);
                    // box.lineTo(785,300);
                    // box.lineTo(890,303);
                    // box.lineTo(892,320);
                    // box.lineTo(980,327);
                    // box.lineTo(1095,335);
                    // box.lineTo(1236,319);
                    // box.lineTo(1724,375);
                    // box.lineTo(1726,935);
                    // box.lineTo(490,930);
                    // box.lineTo(492,332);
                    let line = this.boxList
                    box.moveTo(line[0][0], line[0][1]);
                    for (let j = 1; j < line.length; j++) {
                        box.lineTo(line[j][0], line[j][1]);
                    }
                    box.lineWidth=3;
                    box.fillStyle="rgb(15 ,147, 255, 0.2)";
                    box.strokeStyle="#87d5ff";
                    box.shadowBlur= 5;
                    box.shadowOffsetX = 0;
                    box.shadowOffsetY = 0;
                    box.shadowColor="#b3e4ff";
                    box.stroke();
                    box.fill();
                    box.closePath();
                    this.list.forEach((item,index)=>{
                        context.shadowBlur= 5;
                        context.shadowOffsetX = 0;
                        context.shadowOffsetY = 0;
                        context.shadowColor="#b3e4ff";
                        context.lineWidth = 3;
                        context.strokeStyle = "#87d5ff";
                        context.beginPath();
                        context.moveTo(item[0][0],item[0][1]);
                        context.lineTo(item[1][0],item[1][1]);
                        context.lineTo(item[2][0],item[2][1]);
                        context.lineTo(item[3][0],item[3][1]);
                        context.stroke();
                        context.closePath();
                        // context.lineTo(item[4][0]  ,item[4][1]);
                    })
                        // context.lineWidth=2;
                        // context.strokeStyle="#87d5ff";
                        // context.shadowBlur=5;
                        // context.shadowOffsetX = 5;
                        // context.shadowOffsetY = 5;
                        // context.shadowColor="#87d5ff";


                    canvas.addEventListener('click', function(event){
                        let rect = canvas.getBoundingClientRect();
                        let x = event.clientX - rect.left * (canvas.width / rect.width);
                        let y = event.clientY - rect.top * (canvas.height / rect.height);
                        console.log(x,y)

                        let lines = self.list
                        let numlist = []
                        for (let index = 18; index <= 18; index--) {
                            if(index>1){
                                numlist.push(index)
                            }else{
                                break
                            }
                        }
                        for (let i = 0; i < lines.length; i++) {
                            const line = lines[i];
                            // context.globalCompositeOperation = 'source-atop'
                            context.beginPath();
                            context.moveTo(line[0][0], line[0][1]);
                            for (let j = 1; j < line.length; j++) {
                                context.lineTo(line[j][0], line[j][1]);
                            }
                            context.closePath();
                            if (context.isPointInPath(x, y)) {
                                if(!self.canvasShow){
                                    self.index = numlist[i];
                                    element.style.display = "block"
                                    element.style.left = x+"px";;
                                    element.style.top = y+"px";;
                                    element.style.zIndex = 1000;
                                    // context.fillStyle = "#87d5ff";
                                    // context.fill();
                                    // this.checklist.push(line)
                                }
                                
                            }else{
                                
                                // context.fillStyle = "transparent";
                                // context.fill();
                            }
                        }
                    })
                
                }
               
            },
            onkuan() {
                this.kuan = true;
            },
            full() {
                if(document.documentElement.clientHeight>937){
                    // this.list = this.list1
                    // this.boxList = this.boxList1
                }
                this.isFull = true;
                if(this.$store.state.homeitem.apk=='CH0001'||this.$store.state.homeitem.monitoring.videoCode=='CH0001'){
                    this.PhotovoltaicShow = true
                }else{
                    this.PhotovoltaicShow = false
                }
            },
            cancelFull() {
                this.isFull = false;
                this.PhotovoltaicShow = false;
                let element=document.getElementById("box");
                let w = this.canvas.width;
                let h = this.canvas.height;
                this.box.clearRect(0, 0, w, h);
                this.context.clearRect(0, 0, w, h);
                element.style.display = "none"
                this.PhotovoltaicShow2 = false
                this.canvasShow = true
            },
        },
        beforeDestroy() {
            this.$store.commit("apkAll", null);
        }
    };
</script>

<style lang="less" scoped>
    
    #canvas{
        position: absolute;
        bottom:0;
        width: 100%;
        top: 50%;
        margin-top: -468px;
        left: 50%;
        margin-left: -960px;
    }
.Inverter{
    position: absolute;
    left: 50%;
    top: 25%;
    .nbq{
        position: absolute;
        left: -73px;
        top: 25px;
    }
    .line{
        position: absolute;
        left: -82px;
        top: 66px;
        width: 579rem;
    }
    .line1{
        position: absolute;
        left: -185px;
        top: 53px;
    }

    .bom{
        background: url('../../../assets/img/nbq1.png') no-repeat;
        background-size: 100% 100%;
        width:462rem;
        height:370rem;
        color: #ffffff;
        font-size: 12rem;
        position: absolute;
        top: -230rem;
        padding: 30rem 50rem;
         left: -556rem;
        .text{
            margin-top: 5rem; 
            height: 95rem;
            width: 315rem;
            justify-content: space-between;
            .item{
                width: 45%;
                padding-left: 30rem;
                span{
                    font-size: 18rem;
                    font-weight: bold;
                }
            }
        }
        .info{
            padding:10rem 0;
            .tt{
                font-size: 16rem;
                margin-bottom: 10rem;
            }
            .item{
                width: 33.3%;
                text-align: center;
                span{
                    font-size: 18rem;
                    font-weight: bold;
                }
            }
        }
    }
}
.box{
    background: url(../../../assets/img/nbq2.png) ;
    background-size: 100% 100%;
    width: 258rem;
    height: 168rem;
    margin-top: -168rem;
    /* margin-left: -259rem; */
    padding: 30rem 10px 10px 70rem;
    color: #fff;
    font-size: 16rem;
    box-sizing: border-box;
    .tt{
    font-size: 16rem;

    }
    .cont{
        margin-top: 20rem;
        line-height: 25px;
        span{
            font-weight: 600;
            font-size: 22rem;
        }
    }

}
.Photovoltaic{
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    .button{
        // color: #333;
        // font-size: 16px;
        // background: #fff;
        // border-radius: 23px;
        // display: inline-block;
        position: absolute;
        bottom: 10px;
        // width: 100px;
        left: 10px;
        z-index: 99;
        // padding: 10px 16px;
        // text-align: center;
        img{
            width: 100px;
        }
        cursor: pointer;
    }
}
    .full {
        width: 100vw;
        height: 100vh;
        position: fixed;
        top: 0;
        left: 0;
        background-color: rgba(0, 0, 0, 1);
        z-index: 9999;

    }

    .diagram {
        width: 100%;
        height: 100%;
        overflow: hidden;
        // position: relative;
        background-color: rgba(0, 0, 0, 0);

    }

    .detail {
        font-size: 18rem;
        color: #fff;
        position: absolute;
        top: 24rem;
        left: 24rem;


        display: flex;
        align-items: center;
        cursor: pointer;
    }

    .tableContainer {
        // .w(1473);
        // .h(705);

        z-index: 9999;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    .move-box {
        width: 100%;
        height: 100%;
        position: relative;
        background-color: #000000;


    }

    .small {
        width: 80%;
        height: 100%;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        margin-left: -1px;
        margin-bottom: -1px;
    }
    .isFull{
        position: absolute;
        width: 1536px;
        height: 937px;
        left: 50%;
        top: 50%;
        margin-left: -768px;
        margin-top: -468px;
        transform: translate(0, 0);
    }
    .mask {
        width: 100%;
        height: 100%;

    }

    .btn {
        // .wh(0, -36);
        // position: absolute;
        // top: @h;
        // right: @w;
        position: absolute;
        bottom: 10rem;
        right: 24rem;
        z-index: 99;
        color: #ffffff;
        font-size: 20rem;
        cursor: pointer;

    }

    .upmask {
        height: 90rem;
        position: absolute;
        width: 100%;
        z-index: 9;
        background-image: linear-gradient(rgb(0, 0, 0, 1), rgba(0, 0, 0, 0));

    }

    .Downmask {
        height: 70rem;
        position: absolute;
        width: 100%;
        bottom: 0;
        z-index: 0;
        // background-image: linear-gradient(rgba(0, 0, 0, 0), rgb(0, 0, 0, 1));
        
        background: linear-gradient(0deg, #F3F9FF 0%, rgba(243, 249, 255, 0.3) 100%);
    }
</style>